import React from 'react';
import {
  Row, Col, Popconfirm, Button,
} from 'antd';


const getSalaryPaymentsColumns = (onEditClick, onDeleteClick, onAddClick, financialIsSalaryDone) => [
  {
    title: 'Член коллектива специалистов (ФИО)',
    dataIndex: 'fio',
    key: 'fio',
    render: (text, object) => (object.isAdd && !financialIsSalaryDone ? <Button type="primary" onClick={onAddClick}>Добавить</Button> : text),
  },
  {
    title: 'Роль в проекте/профессия',
    dataIndex: 'rolePosition',
    key: 'rolePosition',
    render: (_, object) => (object.isAdd || object.isTotal ? '' : <div>{`${object.role}/${object.position}`}</div>),
  },
  {
    title: 'Всего начислено',
    dataIndex: 'totalPaid',
    key: 'totalPaid',
    render: (_, object) => (object.isAdd ? '' : <div>{`${object.totalPaidMajor.toString().length === 1 ? `0${object.totalPaidMajor}` : object.totalPaidMajor.toLocaleString('ru-RU')} руб. ${object.totalPaidMinor.toString().length === 1 ? `0${object.totalPaidMinor}` : object.totalPaidMinor} коп. `}</div>),
  },
  {
    title: 'в т.ч. НДФЛ',
    dataIndex: 'ndfl',
    key: 'ndfl',
    render: (_, object) => (object.isAdd ? '' : <div>{`${object.ndflMajor.toString().length === 1 ? `0${object.ndflMajor}` : object.ndflMajor.toLocaleString('ru-RU')} руб. ${object.ndflMinor.toString().length === 1 ? `0${object.ndflMinor}` : object.ndflMinor} коп. `}</div>),
  },
  {
    title: 'ПФР',
    dataIndex: 'pfr',
    key: 'pfr',
    render: (_, object) => (object.isAdd ? '' : <div>{`${object.pfrMajor.toString().length === 1 ? `0${object.pfrMajor}` : object.pfrMajor.toLocaleString('ru-RU')} руб. ${object.pfrMinor.toString().length === 1 ? `0${object.pfrMinor}` : object.pfrMinor} коп. `}</div>),
  },
  {
    title: 'ФОМС',
    dataIndex: 'foms',
    key: 'foms',
    render: (_, object) => (object.isAdd ? '' : <div>{`${object.fomsMajor.toString().length === 1 ? `0${object.fomsMajor}` : object.fomsMajor.toLocaleString('ru-RU')} руб. ${object.fomsMinor.toString().length === 1 ? `0${object.fomsMinor}` : object.fomsMinor} коп. `}</div>),
  },
  {
    title: 'ФСС',
    dataIndex: 'fss',
    key: 'fss',
    render: (_, object) => (object.isAdd ? '' : <div>{`${object.fssMajor.toString().length === 1 ? `0${object.fssMajor}` : object.fssMajor.toLocaleString('ru-RU')} руб. ${object.fssMinor.toString().length === 1 ? `0${object.fssMinor}` : object.fssMinor} коп. `}</div>),
  },
  {
    title: 'ФСС НС',
    dataIndex: 'fssns',
    key: 'fssns',
    render: (_, object) => (object.isAdd ? '' : <div>{`${object.fssnsMajor.toString().length === 1 ? `0${object.fssnsMajor}` : object.fssnsMajor.toLocaleString('ru-RU')} руб. ${object.fssnsMinor.toString().length === 1 ? `0${object.fssnsMinor}` : object.fssnsMinor} коп. `}</div>),
  },
  {
    title: 'ИТОГО по сотруднику',
    dataIndex: 'totalPerson',
    key: 'totalPerson',
    render: (_, object) => (object.isAdd ? '' : <div>{`${object.totalPersonMajor.toString().length === 1 ? `0${object.totalPersonMajor}` : object.totalPersonMajor.toLocaleString('ru-RU')} руб. ${object.totalPersonMinor.toString().length === 1 ? `0${object.totalPersonMinor}` : object.totalPersonMinor} коп. `}</div>),
  },
  {
    title:
  <Col>
    <Row>Кассовый  расход</Row>
  </Col>,
    dataIndex: 'actualPaid',
    key: 'actualPaid',
    render: (_, object) => (object.isAdd ? '' : <div>{`${object.actualPaidMajor.toString().length === 1 ? `0${object.actualPaidMajor}` : object.actualPaidMajor.toLocaleString('ru-RU')} руб. ${object.actualPaidMinor.toString().length === 1 ? `0${object.actualPaidMinor}` : object.actualPaidMinor} коп. `}</div>),
  },
  {
    title: 'Остаток к уплате',
    dataIndex: 'remain',
    key: 'remain',
    render: (_, object) => (object.isAdd ? '' : <div>{`${object.remainMajor.toString().length === 1 ? `0${object.remainMajor}` : object.remainMajor.toLocaleString('ru-RU')} руб. ${object.remainMinor.toString().length === 1 ? `0${object.remainMinor}` : object.remainMinor} коп. `}</div>),
  },
  {
    title: '',
    dataIndex: 'actions',
    key: 'actions',
    width: '5%',
    render: (_, object) => (
      <div>
        {!object.isTotal && !object.isAdd && !financialIsSalaryDone && (
        <Col gutter={5}>
          <Row style={{ cursor: 'pointer' }}><Button type="link" style={{ padding: 0 }} onClick={() => onEditClick(object)}>изменить</Button></Row>
          <Row style={{ cursor: 'pointer' }}>
            <Popconfirm
              title="Вы уверены, что хотите удалить?"
              onConfirm={() => onDeleteClick(object)}
              okText="Да"
              cancelText="Нет"
            >
              <Button type="link" style={{ padding: 0 }}>удалить</Button>
            </Popconfirm>
          </Row>
        </Col>
        )}
      </div>
    ),
  },
];

export default getSalaryPaymentsColumns;
